import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Tooltip, Steps, Button, message } from 'antd';

import 'antd/dist/antd.css';

import Exchanges from '../exchanges/Exchanges';
import ImportExchanges from '../importExchanges/ImportExchanges';
import Processor from '../processor/Processor';

import styles from './Workflow.css';

import {
  next,
  prev,
  resetPosition,
  selectCurrent,
  selectUploadCompleteStatus,
} from './workflowSlice';

import { resetExchanges } from '../exchanges/exchangesSlice';
import { resetTransactions } from '../upload/uploadSlice';

const { Step } = Steps;

const steps = [
  {
    title: '1. Select Exchanges',
    content: <Exchanges />,
  },
  {
    title: '2. Import Transactions',
    content: <ImportExchanges />,
  },
  {
    title: '3. Run the Numbers',
    content: <Processor />,
  },
];

export default function Workflow() {
  const dispatch = useDispatch();
  const current = useSelector(selectCurrent);
  const uploadStatus = useSelector(selectUploadCompleteStatus);

  return (
    <div>
      <div className={styles.container}>
        <Steps current={current}>
          {steps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>

        <div className={styles.stepsContent}>{steps[current].content}</div>

        <div className={styles.stepsAction}>
          {current < steps.length - 1 && (
            <Tooltip title="Please upload all exchanges." trigger="hover">
              <Button
                type="primary"
                disabled={current == 1 && !uploadStatus}
                onClick={() => dispatch(next())}
              >
                Next
              </Button>
            </Tooltip>
          )}
          {current === steps.length - 1 && (
            <Button
              type="primary"
              onClick={() => {
                dispatch(resetPosition());
                dispatch(resetExchanges());
                dispatch(resetTransactions());
              }}
            >
              Start Over
            </Button>
          )}
          {current == 1 && (
            <Button
              style={{ margin: '0 8px' }}
              onClick={() => dispatch(prev())}
            >
              Previous
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
